














import { UserStatus } from '@/resource/user/user.model';
import { getUserStatus } from '@/utils/cookie';
import { Component, Prop, Vue } from 'vue-property-decorator';

enum AdsenseStatus {
  Filled = 'filled',
  Unfilled = 'unfilled',
}

@Component({
  components: {},
})
export default class Adsense extends Vue {
  @Prop({ default: null })
  width: string;

  @Prop({ default: null })
  height: string;

  @Prop({ required: true })
  adSlotId: string;

  @Prop({ default: 'auto' })
  adFormat: string;

  @Prop({ default: null })
  actionUnfilledAd: null | Function;

  statusObserver: null | MutationObserver = null;

  get adDivId() {
    return `adsense-${this.adSlotId}`;
  }

  get adStyle() {
    let adStyle = 'display:block;';

    if (this.width) {
      adStyle += `width: ${this.width}px;`;
    }

    if (this.height) {
      adStyle += `height: ${this.height}px;`;
    }

    return adStyle;
  }

  get userStatus(): UserStatus {
    return getUserStatus() || UserStatus.Free;
  }

  get isPremiumStatus() {
    return this.userStatus === UserStatus.Premium;
  }

  mounted() {
    if (this.isPremiumStatus) return;

    // this.$sendMpEvent({
    //   event: this.$mp_value.AdsenseRequest,
    //   mixpanelSecond: true,
    // });
    // this.observeAdStatus();
    // ((window as any).adsbygoogle = (window as any).adsbygoogle || []).push({});
  }

  observeAdStatus() {
    const DATA_AD_STATUS = 'data-ad-status';
    // Select the node that will be observed for mutations
    const targetNode = document.getElementById(this.adDivId);

    if (targetNode) {
      // Options for the observer (which mutations to observe)
      const config = { attributes: true };

      // Callback function to execute when mutations are observed
      const callback = (mutations: MutationRecord[]) => {
        for (const mutation of mutations) {
          if (mutation.type === 'attributes') {
            if (mutation.attributeName === DATA_AD_STATUS) {
              const target = mutation.target as any;

              if (target) {
                const status = target.getAttribute(DATA_AD_STATUS);

                if (status === AdsenseStatus.Filled) {
                  console.log('ads-status-filled');
                  console.log('attributeName:', mutation.attributeName);
                  console.log('status:', status);
                  this.$sendMpEvent({
                    event: this.$mp_value.AdsenseFilled,
                    mixpanelSecond: true,
                  });
                } else if (status === AdsenseStatus.Unfilled) {
                  console.log('ads-status-Unfilled');
                  console.log('attributeName:', mutation.attributeName);
                  console.log('status:', status);
                  this.$sendMpEvent({
                    event: this.$mp_value.AdsenseUnfilled,
                    mixpanelSecond: true,
                  });
                  this.actionUnfilledAd && this.actionUnfilledAd();
                }
              }
            }
          }
        }
      };

      // Create an observer instance linked to the callback function
      this.statusObserver = new MutationObserver(callback);

      // Start observing the target node for configured mutations
      this.statusObserver.observe(targetNode, config);
    }
  }

  beforeDestroy() {
    // NOTE: Unmount and stop observing
    if (this.statusObserver) {
      this.statusObserver.disconnect();
    }
  }
}
